<template>
  <div @click="onMarkerClick">
    <div class="wrapper">
      <div :class="styles.colorAndOpacity(location, selected)" />
      <AppPopup v-if="selected && pupUpable" @close="close()">
        <PopupContent
          :delivery-setting="deliverySetting"
          :location="location"
          :selected-group="selectedGroup"
          :readonly="readonly"
          class="popupContent"
        />
      </AppPopup>
      <div class="filler" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppPopup from '@/components/App/AppPopup'
import PopupContent from '@/components/Shared/Simulation/SimulationContentDeliveryContentMarkerWrapperPopup'
import markerUIStyles from '@/components/Shared/Simulation/util/markerStyle'
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'

export default {
  name: 'SimulationContentDeliveryContentMarkerUI',
  components: {
    AppPopup,
    PopupContent,
  },
  props: {
    deliverySetting: {
      type: Object,
      default: () => {},
    },
    selectedGroup: {
      type: Object,
      default: () => {},
    },
    location: {
      type: Object,
      default: () => {},
    },
    selected: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('simulation', ['selectedGroupType']),
    pupUpable() {
      return this.selectedGroupType !== locationGroupType.POI_LOCATION
    },
    styles() {
      return markerUIStyles
    },
  },
  methods: {
    ...mapActions('simulation', {
      selectLocation: 'SELECT_LOCATION',
      deselectLocation: 'DESELECT_LOCATION',
    }),
    onMarkerClick(e) {
      e.stopPropagation()
      this.selectLocation(this.location)
    },
    close() {
      this.deselectLocation()
    },
  },
}
</script>

<style scoped>
.wrapper {
  position: relative;
  top: -20px;
  left: -10px;
}
.popupContent {
  position: relative;
  top: 0;
  left: 0;
}
.filler {
  position: absolute;
  top: -2px;
  left: -9px;
  background-color: transparent;
  width: 40px;
  height: 40px;
  cursor: move;
}
</style>
